import { useEffect, useState } from 'react';
import { makeApiRequests } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';
import { saveUserToLocal } from '../helpers/session';

export default function useSessionProbe(options = {}) {
  const persistProfile = Boolean(options.persistProfile);
  const [sessionReady, setSessionReady] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { response } = await makeApiRequests({
        endpoint: ENDPOINTS.USERS_ME,
        method: 'GET',
        authSilent: true
      });
      if (cancelled) return;
      if (response) {
        setIsLoggedIn(true);
        setUser(response);
        if (persistProfile) {
          saveUserToLocal(response);
        }
      } else {
        setIsLoggedIn(false);
        setUser(null);
      }
      setSessionReady(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [persistProfile]);

  return { sessionReady, isLoggedIn, user };
}
